import { ComponentLoader } from '@bythepixel/component-loader';
import mobileNavigationMenu from './mobileNavigationMenu';
import ToggleButton from './toggleButton';
import DealerLocatorForm from '../components/dealerLocatorForm';
import initDealerLocator from '../dealerLocator';

window.basicPage = new ComponentLoader(document, [
  mobileNavigationMenu,
  ToggleButton,
  DealerLocatorForm,
], () => {
  initDealerLocator();
});
